import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


const emptyLine = () => ({ transactionDate: '', description: '', amount: '', matched: false, journalEntryId: '' });

export default function AddBankReconciliation() {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [form, setForm] = useState({ accountId: '', statementDate: new Date().toISOString().split('T')[0], statementBalance: '', status: 'IN_PROGRESS' });
  const [lines, setLines] = useState([emptyLine()]);

  useEffect(() => {
    api(`/accounts`).then(r => r.json()).then(setAccounts).catch(() => {});
  }, []);

  const updateLine = (i, field, value) => { const u = [...lines]; u[i] = { ...u[i], [field]: value }; setLines(u); };
  const addLine = () => setLines([...lines, emptyLine()]);
  const removeLine = (i) => setLines(lines.filter((_, idx) => idx !== i));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      ...form, statementBalance: parseFloat(form.statementBalance) || 0,
      lines: lines.filter(l => l.transactionDate).map(l => ({
        transactionDate: l.transactionDate, description: l.description,
        amount: parseFloat(l.amount) || 0, matched: l.matched,
        journalEntryId: l.journalEntryId || null,
      })),
    };
    const res = await api(`/bank-reconciliations`, { method: 'POST', body: JSON.stringify(body) });
    if (res.ok) {
      const recon = await res.json();
      navigate(`/accounting/bank-reconciliations/${recon.id}`);
    }
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">New Bank Reconciliation</h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Account *</label><select required value={form.accountId} onChange={(e) => setForm({...form, accountId: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600"><option value="">Select account</option>{accounts.map(a => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}</select></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Statement Date *</label><input type="date" required value={form.statementDate} onChange={(e) => setForm({...form, statementDate: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600" /></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Statement Balance *</label><input type="number" step="0.01" required value={form.statementBalance} onChange={(e) => setForm({...form, statementBalance: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600" /></div>
          </div>

          <div>
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-lg font-semibold text-gray-900">Statement Lines</h2>
              <button type="button" onClick={addLine} className="text-emerald-600 hover:text-emerald-800 text-sm font-medium">+ Add Line</button>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50"><tr><th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Date</th><th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Description</th><th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">Amount</th><th className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase">Matched</th><th className="px-4 py-2"></th></tr></thead>
                <tbody>
                  {lines.map((line, i) => (
                    <tr key={i}>
                      <td className="px-4 py-2"><input type="date" value={line.transactionDate} onChange={(e) => updateLine(i, 'transactionDate', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" /></td>
                      <td className="px-4 py-2"><input type="text" value={line.description} onChange={(e) => updateLine(i, 'description', e.target.value)} className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" /></td>
                      <td className="px-4 py-2"><input type="number" step="0.01" value={line.amount} onChange={(e) => updateLine(i, 'amount', e.target.value)} className="w-28 px-2 py-1 border border-gray-300 rounded text-right text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" /></td>
                      <td className="px-4 py-2 text-center"><input type="checkbox" checked={line.matched} onChange={(e) => updateLine(i, 'matched', e.target.checked)} className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-600" /></td>
                      <td className="px-4 py-2">{lines.length > 1 && <button type="button" onClick={() => removeLine(i)} className="text-red-500 hover:text-red-700 text-sm">✕</button>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <button type="button" onClick={() => navigate('/accounting/bank-reconciliations')} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">Save</button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
